import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { Divider } from './styles.js';

const DropdownDivider = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement("li", null,
        React.createElement(Divider, Object.assign({}, props))));
};

export { DropdownDivider as default };
